import { jsx, jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { Footer } from "../Footer.js";
import { Actions } from "./components/Actions.js";
import { HexInput } from "./components/HexInput/HexInput.js";
import { Hue } from "./components/Hue/Hue.js";
import { Saturation } from "./components/Saturation/Saturation.js";
import { usePicker } from "./hooks/usePicker/usePicker.js";
function Picker(props) {
  const { onCancel, onCommit } = props;
  const { saturation, hue } = usePicker(props);
  return /* @__PURE__ */ jsxs(Stack, { gap: 2, padding: 0.25, children: [
    /* @__PURE__ */ jsx(Actions, {}),
    /* @__PURE__ */ jsx(
      Saturation,
      {
        onChange: saturation.onMoveSaturation,
        ref: saturation.ref,
        style: saturation.styles,
        cursor: saturation.cursor
      }
    ),
    /* @__PURE__ */ jsx(Hue, { onChange: hue.onMoveHue, ref: hue.ref, cursor: hue.cursor, style: hue.styles }),
    /* @__PURE__ */ jsx(HexInput, {}),
    /* @__PURE__ */ jsx(Footer, { onCancel, onCommit })
  ] });
}
export {
  Picker
};
//# sourceMappingURL=Picker.js.map
